'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var options = {
    template: require('./home.html'),
    bindings: {
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$stateParams", "productOverviewService", "advertService", "newsService", "cartService", "Enums", "common", "gettextCatalog", "authService", "Analytics", "$location", "$timeout", "exceptionService", "productService", "reservationCampaignService", "$window", "$state", function controller($scope, $stateParams, productOverviewService, advertService, newsService, cartService, Enums, common, gettextCatalog, authService, Analytics, $location, $timeout, exceptionService, productService, reservationCampaignService, $window, $state) {
        'ngInject';

        var vm = this;
        vm.adverts = null;
        vm.discountsModel = null;
        vm.errorOccurredInProductOverview = false;
        vm.newsitems = null;
        vm.products = null;
        vm.addToCart = addToCart;
        vm.advertClicked = advertClicked;
        vm.buildUrl = buildUrl;
        vm.activeCampaigns = [];
        vm.isFebelcoCustomer = false;
        vm.$onInit = init;
        vm.onChangeQuantity = onChangeQuantity;
        vm._badgeClicked = _badgeClicked;
        vm.getProductDiscounts = getProductDiscounts;
        $scope.forms = {};

        function init() {
            common.navigationMenu.setHomeActive();
            common.setTitle(gettextCatalog.getString('Profficina'));

            //GA
            Analytics.trackPage('/' + common.localization.getCurrentLanguage(), gettextCatalog.getString('Profficina'));

            //get the settings for the sliders
            vm.productSliderSettings = productOverviewService.getProductSliderSettings();
            vm.newsSliderSettings = newsService.getNewsSliderSettings();

            vm.isFebelcoCustomer = authService.isFebelcoCustomer;
            if (vm.isFebelcoCustomer) {
                reservationCampaignService.getActiveReservationCampaigns().then(function (response) {
                    vm.activeCampaigns = response;
                });
            }

            //load the adverts. Refactor code so it can be put in resolve with loading spinners shown
            advertService.getAdvertsForHomepage().then(function (model) {
                vm.adverts = model;
                angular.forEach(vm.adverts, function (advert) {
                    Analytics.addPromo(advert.id, advert.name, $state.current.name + ' ' + advert.sequenceNr, '');
                });
                //Analytics.pageView(); // Homepage werd 2x getrackt hierdoor
            });

            //load the news items. Do not put in resolve or loading spinners will not be shown
            newsService.getNewsForHomepage().then(function (model) {
                vm.newsitems = model;
            });

            //load the product items. do not put in resolve or loading spinners will not be shown
            vm.discountsModel = productOverviewService.init(Enums.searchContext.discount.id);
            productOverviewService.getProductsForHomepage(true, vm.discountsModel).then(function (model) {
                vm.discountsModel = model;
                vm.products = model.products;
                vm.errorOccurredInProductOverview = model.errorOccurred;
            });

            //update quantity on enter
            angular.element($window).on('keydown', function (event) {
                if (event.which === 13 && vm.addingProducts !== true) {
                    vm.addToCart();
                }
            });

            $scope.$on('$destroy', function () {
                angular.element($window).off('keydown');
            });
        }

        function advertClicked(advert) {
            Analytics.addPromo(advert.id, advert.name, $state.current.name + ' ' + advert.sequenceNr, '');
            Analytics.promoClick('Home');
        }

        function buildUrl(url) {
            return $location.path() + url;
        }

        function _badgeClicked(categoryId) {
            vm.badgeClicked({
                categoryId: categoryId
            });
        }

        function onChangeQuantity() {
            vm.productsQuantityChanged = true;
            vm.productsAdded = false;
            vm.isOpen = true;
        }

        function addToCart() {
            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;
            cartService.updateCartOverview(vm.products).then(function (shoppingCartProducts) {
                if ($scope.forms.productOverviewForm) {
                    $scope.forms.productOverviewForm.$setPristine();
                }
                vm.addingProducts = false;
                vm.productsAdded = true;
                vm.addToCartEnabled = true;
                vm.shoppingCartProducts = shoppingCartProducts;

                vm.products.map(function (product) {
                    return product = product.getCartFields(product, shoppingCartProducts);
                });

                $timeout(function () {
                    vm.productsAdded = false;
                    vm.isOpen = false;
                }, 5000);
            }).catch(function () {
                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                vm.isOpen = false;
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                exceptionService.logException(msg);
                vm.hasError = true;
                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
            });
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};

exports.default = options;


//////////////////
// WEBPACK FOOTER
// ./features/home/home.js
// module id = 936
// module chunks = 0